export const SET_ORDER_TYPE_INITIAL = 'orderingMode/SET_ORDER_TYPE_INITIAL';
